import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, programManagementURL } from '../../../../../../../Containers/Config/index.js';
import apiCall from '../../../../../apiCall.js';
import {
  UPDATE_DASHBOARD_CONFIG,
  UPDATE_DASHBOARD_CONFIG_ERROR,
  UPDATE_DASHBOARD_CONFIG_SUCCESS,
} from '../../../../../actionType.js';

// PUT /api/v1/dashboard-configs — stores the canvas layout (JSON schema)
// against a role + sidebar key on the program-management service.
function* updateDashboardConfig({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/dashboard-configs`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: UPDATE_DASHBOARD_CONFIG_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPDATE_DASHBOARD_CONFIG_ERROR,
        payload: response?.response?.data?.message || response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_DASHBOARD_CONFIG_ERROR, payload: error });
  }
}

export function* watchUpdateDashboardConfig() {
  yield takeEvery(UPDATE_DASHBOARD_CONFIG, updateDashboardConfig);
}

function* updateDashboardConfigSaga() {
  yield all([fork(watchUpdateDashboardConfig)]);
}

export default updateDashboardConfigSaga;
